// components/PrivateRoute.js
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { isTokenExpired } from "../utilis/auth";

const PrivateRoute = ({ children }) => {
  const token = useSelector((state) => state.user.token);

  if (!token || isTokenExpired(token)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
